import { z } from 'zod'
import { AssigneeTypeEnum } from '@omnea-app/packages/universal/hasura/graphql'

export const FormAssigneeTypeSchema = z.enum(['primary_supplier_contact', 'user', 'someone_else'])
export const FormAssigneeSchema = z.object({
  // form-level source type
  type: FormAssigneeTypeSchema.optional(),
  email: z.string().nullish(),
  name: z.string().nullish(),
  jobTitle: z.string().nullish(),
  // system-level assignee type, carried from supplierPortalAssignees so resolved assignees (USER, GROUP) aren't mistreated as EMAIL
  assigneeType: z.nativeEnum(AssigneeTypeEnum).optional(),
  id: z.string().optional(),
  value: z.string().optional(),
})
export const ProductAndServicePayloadSchema = z.object({
  createdAt: z.string().nullish(),
  deletedAt: z.string().nullish(),
  description: z.string().nullable(),
  displayName: z.string(),
  formAssignees: z.array(FormAssigneeSchema).optional(),
  id: z.string().nullable(),
  logoUrl: z.string().nullable(),
  name: z.string().nullable(),
  primaryContactEmail: z.string().nullish(),
  primaryContactJobTitle: z.string().nullish(),
  primaryContactName: z.string().nullish(),
  productsAndServicesId: z.string().nullish(),
  supplier: z
    .object({
      id: z.string().nullable(),
      isReseller: z.boolean(),
      logoUrl: z.string().nullable(),
      name: z.string().nullish(),
      website: z.string().nullable(),
      isExisting: z.boolean().optional(),
    })
    .nullable()
    .optional(),
  organisation_supplier: z
    .object({
      id: z.string().nullable(),
      logoUrl: z.string().nullable(),
      name: z.string().nullish(),
      website: z.string().nullable(),
    })
    .nullable()
    .optional(),
  updatedAt: z.string().nullish(),
  website: z.string().nullable(),
  isPrefilled: z.boolean().optional(),
  hasSupplierContact: z.boolean().optional(),
})
export type FormAssigneeType = z.infer<typeof FormAssigneeTypeSchema>
export type FormAssignee = z.infer<typeof FormAssigneeSchema>
export type ProductAndServicePayload = z.infer<typeof ProductAndServicePayloadSchema>
